/*
 * @Author: zcj
 * @Date: 2025-07-10 10:19:30
 * @LastEditTime: 2025-07-10 16:23:20
 * @LastEditors: zcj 2736104855@qq.com
 * @Description: 点击事件拦截器
 * @FilePath: \h5e:\travel-app\src\interceptors\clickInterceptor.ts
 */
let lastTapTime = 0;

export function setupClickInterceptor() {
  // 拦截页面点击事件
  const originTouchstart = uni.onTouchStart;
  
  uni.onTouchStart = function(e) {
    const nowTime = Date.now();
    if (nowTime - lastTapTime < 1000) {
      // 阻止连点
      e.preventDefault && e.preventDefault();
      e.stopPropagation && e.stopPropagation();
      return;
    }
    lastTapTime = nowTime;
    return originTouchstart && originTouchstart.apply(this, arguments);
  };
}